"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WALLETCONNECT_ELROND_CHAIN_ID = void 0;
// Wallet Connect ChainId for Elrond blockchain
exports.WALLETCONNECT_ELROND_CHAIN_ID = 508;
//# sourceMappingURL=constants.js.map